<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script src="http://int.dpool.sina.com.cn/iplookup/iplookup.php?format=js"></script>
<script>
	var city = remote_ip_info['city'];
</script>
<script>
	export default {
		name: 'app',
		components: {
		},
		//监听器
		watch: {
			// 方法1
			'$route'(to, from) { //监听路由是否变化
				if (to.path == "/") { //跳转到哪个页面
					location.reload()
				}
			},
		},
		mounted(e) {
			var domain = window.location.href; //先获取当前访问的全域名

		},
		methods: {
			 is_weixn(){  
			    var ua = navigator.userAgent.toLowerCase();  
			    if(ua.match(/MicroMessenger/i)=="micromessenger") {  
			        return true;  
			    } else {  
			        return false;  
			    }  
			},
			_isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag;
			},

		}
	}
</script>
<style>
	body {
		overflow-x: hidden;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	img {
		object-fit: cover;
	}

	a:hover {
		text-decoration: none;
	}

	.no-padding-top {
		padding-top: 0px !important;
	}

	.pointer:hover {
		cursor: pointer;
		background: #f0f4f5;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170 !important;
	}


	em {
		font-style: normal;
	}

	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.pointer {
		cursor: pointer;
	}

	.pointer:hover {
		cursor: pointer;
		background: #f0f4f5;
	}

	.line-1 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	.line-2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.line-3 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.line-4 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		-webkit-box-orient: vertical;
	}

	.line-7 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 7;
		-webkit-box-orient: vertical;
	}



	/*全局按钮样式 GO*/
	.btn_square {
		position: relative;
		cursor: pointer;
		overflow: hidden;
	}

	.btn_square em {
		position: relative;
		z-index: 9;
		font-style: normal;
	}

	.btn_square::after {
		content: '';
		width: 100%;
		height: 100%;
		background: #333333;
		display: block;
		position: absolute;
		top: 0;
		left: -100%;
		z-index: 8;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.btn_square:hover::after {
		left: 0px;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	.btn_small {
		width: 160px;
		height: 42px;
		float: right;
		display: flex;
		align-items: center;
		background: #006170;
		color: #ffffff;
		line-height: 42px;
		padding-left: 30px;
	}

	.btn_square span {
		width: 17px;
		height: 17px;
		display: flex;
		z-index: 9;
		position: relative;
		/* top: 3px; */
		margin-left: 20px;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}

	.el-pagination .btn-prev,
	.el-pagination .btn-next {
		width: 30px;
	}

	.el-loading-parent--hidden {
		overflow: scroll !important
	}
</style>
